import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _resetUpdatesCounterRequest = {};
var _resetUpdatesCounterResponse = {};
function resolveWixSocialGroupsApiV2GroupUpdatesServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/social-groups-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function resetUpdatesCounter(payload) {
    return function __resetUpdatesCounter(_a) {
        var host = _a.host;
        var toJSON = serializer(_resetUpdatesCounterRequest, {}).toJSON;
        var fromJSON = serializer(_resetUpdatesCounterResponse, {}).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2GroupUpdatesServiceUrl({
                protoPath: '/v2/{groupId}/updates',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
//# sourceMappingURL=http.js.map